export default "__VITE_ASSET__CaSEq_dp__"